import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Form, Field } from 'react-final-form';


export default function RadioButtonsGroup(props) {

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{props.title}</FormLabel>
      <Field name={props.name}>{(f)=>
        <RadioGroup aria-label="gender" name="gender1" value={f.input.value} onChange={f.input.onChange}>
          {props.select_data.map(function(d){
            return(<FormControlLabel value={d.value} control={<Radio />} label={d.name} />)
          })}
        </RadioGroup>
      }</Field>
    </FormControl>
  );
}
